import { Icon } from '@conekta/frontino-ui/Icon';

import './styles.scss';
import { useTranslation } from '@conekta/cronos/i18n';
import { sendAnalytic } from 'app/util/analytics';
import { AnalyticEvents } from 'app/util/constants';

import { ChangeLanguageSelectWrapper, ChangeLanguageWrapper } from './ChangeLanguageWrapper';
import { languages } from './constants';

export interface IChangeLanguage {
  id: string;
  companyId: string;
  type: string;
  color?: string;
}

export const ChangeLanguage = ({ id, companyId, type, color }: IChangeLanguage) => {
  const { ES, EN } = languages;
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const handleClick = (event: any) => {
    const currentURL = window.parent.location.href.split('?')[0];
    sendAnalytic(AnalyticEvents.langSelection, id, companyId, type);
    window.parent.location.assign(`${currentURL}?locale=${event.target.value}`);
  };

  return (
    <ChangeLanguageWrapper color={color} className='checkout-change-language'>
      <Icon className='checkout-change-language__title-icon' size='medium'>
        language
      </Icon>
      <ChangeLanguageSelectWrapper
        color={color}
        className='checkout-change-language__select'
        onChange={handleClick}
        defaultValue={currentLanguage}
      >
        <option value={ES}>ES</option>
        <option value={EN}>EN</option>
      </ChangeLanguageSelectWrapper>
    </ChangeLanguageWrapper>
  );
};
